import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import {AntragsannahmeAppModule} from './app/antragsannahmeApp.module';
import {environment} from './environments/environment';

if (environment.production) {
  enableProdMode();
}
if (window.location.href.includes('success')){
  window.location.href = 'https://www.lv1871.de/lv/antrag-erfolgreich-eingegangen';
}

platformBrowserDynamic().bootstrapModule(AntragsannahmeAppModule)
    .catch(err => console.error(err));
